import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';

const fadeUp = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.24, ease: [0.2, 0.8, 0.2, 1] } }
};

/**
 * Header del Dashboard con título y botones de acción (Actualizar + Exportar CSV).
 *
 * @param {boolean} refreshing
 * @param {function} onRefresh
 * @param {function} onExport
 */
export function DashboardHeader({ refreshing, onRefresh, onExport }) {
  return (
    <motion.div initial="hidden" animate="show" variants={fadeUp}>
      <div style={{
        background: 'linear-gradient(150deg, #0d3d1f 0%, #1a5c2e 40%, #2d8a4e 80%, #3aaa62 100%)',
        borderRadius: '16px', padding: '22px 28px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px',
        boxShadow: '0 4px 24px rgba(26,92,46,0.2)',
        position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle at 85% 50%, rgba(110,201,98,0.1) 0%, transparent 60%)', pointerEvents: 'none' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: '18px', position: 'relative' }}>
          <img src="/valoriza-logo.svg" alt="Valoriza" style={{ height: '36px', filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.2))' }} />
          <div style={{ borderLeft: '1px solid rgba(255,255,255,0.25)', paddingLeft: '18px' }}>
            <h1 style={{ fontFamily: 'Space Grotesk', fontSize: '22px', fontWeight: 700, color: '#fff', margin: 0 }}>
              Panel de Control
            </h1>
            <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '13px', margin: '2px 0 0' }}>
              Seguimiento de altas, estado de correos y actividad reciente.
            </p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '10px', position: 'relative' }}>
          <Button
            data-testid="dashboard-refresh-button"
            onClick={onRefresh}
            disabled={refreshing}
            style={{ height: '38px', fontSize: '13px', background: 'rgba(255,255,255,0.12)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', backdropFilter: 'blur(4px)' }}
          >
            {refreshing ? '⏳' : '🔄'} Actualizar
          </Button>
          <Button
            onClick={onExport}
            data-testid="dashboard-export-csv-button"
            style={{ height: '38px', fontSize: '13px', background: 'rgba(255,255,255,0.95)', color: '#1a5c2e', fontWeight: 700 }}
          >
            ↓ Exportar ISO CSV
          </Button>
        </div>
      </div>
    </motion.div>
  );
}

export default DashboardHeader;
